import { makeFunctionCall } from "@/firebase/clientApp"

export const payments_createCustomerSession = makeFunctionCall<
  { currency: string },
  { customerSessionClientSecret: string }
>("payments_createCustomerSession")
